/**
 * Get Projects Use Case
 *
 * Retrieves all projects for the current user.
 * This use case orchestrates the business logic for fetching projects.
 */

import type { IProjectsGateway } from "../ports/IProjectsGateway";
import type { ProjectDTO } from "../dtos/ProjectDTO";

export class GetProjectsUseCase {
  constructor(private readonly projectsGateway: IProjectsGateway) {}

  async execute(): Promise<ProjectDTO[]> {
    return this.projectsGateway.getProjects();
  }
}
